import { useEffect, useState } from 'react';
import Toast from 'components/Toast';
import APP from 'stores/APP';
import { loadScript } from 'utils/loadScript';

export const PLAID_SCRIPT_ID = 'plaid-script';

const PLAID_LINK_STABLE_URL = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';

interface PlaidLinkOptions {
    receivedRedirectUri?: string;
    token?: string;
    redirect_uri?: string;
    onSuccess?: (public_token: string) => void;
    onExit?: (error, metadata) => void;
}

const usePlaidLink = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const loadSdk = async () => {
        setLoading(true);
        setError(null);

        const scriptFile = document.getElementById(PLAID_SCRIPT_ID);

        if (scriptFile && window.Plaid) {
            setLoading(false);

            return;
        }

        try {
            await loadScript(false, PLAID_LINK_STABLE_URL, PLAID_SCRIPT_ID);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError(error);
        }
    };

    useEffect(() => {
        loadSdk();
    }, []);

    const openPlaid = (options: PlaidLinkOptions) => {
        if (loading || error) {
            return;
        }

        const { onExit, ...rest } = options;

        // plaid文档： https://plaid.com/docs/link/web/#link-web-create-receivedRedirectUri
        const handler = window.Plaid.create({
            clientName: 'TradeUP',
            countryCodes: ['US'],
            env: APP.isDev ? 'sandbox' : 'production',
            product: ['auth'],
            language: 'en',
            ...rest,
            onExit: (error, metadata) => {
                if (error != null) {
                    // 拼接错误信息和request_id（提供给plaid用来检查绑卡失败的原因）
                    Toast.show(
                        `${error.error_message} ${metadata?.request_id ? `(request_id: ${metadata.request_id})` : ''}`
                    );
                }

                onExit?.(error, metadata);
            }
        });

        handler.open();
    };

    return {
        loading,
        error,
        open: openPlaid,
        loadSdk
    };
};

export default usePlaidLink;
